import styled from "styled-components";
import { useSelector } from "react-redux";

// import * as styles from "styles";
import { back1, back2 } from "images";
import * as Types from "Types";
import * as grid from "grid";

import Head from "Components/Molecules/SectionHead";
import OrganismAbout from "Components/Organisms/SectionAbout";
import OrganismChannels from "Components/Organisms/SectionChannels";
import OrganismTimeline from "Components/Organisms/SectionTimeline";
import OrganismXSTimeline from "Components/Organisms/XSSectionTimeline";
import OrganismPartners from "Components/Organisms/SectionPartners";
import OrganismXSPartners from "Components/Organisms/XSSectionPartners";
import OrganismPress from "Components/Organisms/SectionPress";

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
   overflow: hidden;
   ${({ css }) => css}
`;

const BackgroundWrap = styled.div`
   position: relative;
   width: 100%;
`;

const Background = styled.div`
   position: absolute;
   z-index: 0;
   bottom: 0px;
   left: 50%;
   transform: translateX(-50%);
   min-width: 1400px;
   width: 100%;
   height: 2000px;
   background-image: url(${back2}), url(${back1});
   background-repeat: no-repeat, no-repeat;
   background-position: bottom 0 left 0, bottom 550px left 0;
   background-size: 100% 750px, 100% 850px;
`;
const XSBackground = styled.div`
   position: absolute;
   z-index: 0;
   bottom: 0px;
   left: 50%;
   transform: translateX(-50%);
   min-width: 1400px;
   width: 100%;
   height: 1200px;
   background-image: url(${back2}), url(${back1});
   background-repeat: no-repeat, no-repeat;
   background-position: bottom 0 left 0, bottom 500px left -400px;
   background-size: 100% 700px, 100% 650px;
`;

const Line = styled.div`
   width: 100%;
   height: 13px;
   opacity: 0.1;
   background-color: #e5e5e5;
   margin-top: 150px;
`;

const XSLine = styled.div`
   width: 100%;
   height: 13px;
   opacity: 0.1;
   background-color: #e5e5e5;
   margin-top: 70px;
`;
export default function About(props: Types.Default) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const shows = grid.shows({
      width: windowWidth,
      grids: { xs: false },
   });
   return (
      <Wrap {...props}>
         <Head></Head>
         <BackgroundWrap>
            {shows ? <Background></Background> : <XSBackground></XSBackground>}
            <OrganismAbout></OrganismAbout>
            <OrganismChannels></OrganismChannels>
         </BackgroundWrap>
         {shows ? <OrganismTimeline></OrganismTimeline> : <OrganismXSTimeline></OrganismXSTimeline>}
         {shows ? <Line></Line> : <XSLine></XSLine>}
         {shows ? <OrganismPartners></OrganismPartners> : <OrganismXSPartners></OrganismXSPartners>}
         <OrganismPress></OrganismPress>
      </Wrap>
   );
}
